module.exports = __webpack_public_path__ + "static/media/empty.c353b685.png";